import "./webchat_loader.scss";

let NSconfig = {};
let conversation_app_container = undefined;
// let service_ip = "http://192.168.78.97:3500";
// let service_ip = "https://services.stage.askfor-app.com";
let service_ip = "https://services.conversation-inc.com";

let lib = {
    init: function(config) {
        NSconfig = config;
        if (!NSconfig.api_key || NSconfig.api_key=="") {
            console.error("API KEY not defined");
            return;
        }

        conversation_app_container = document.getElementById("conversation-root");
        if (!conversation_app_container) {
            conversation_app_container = document.createElement('div');
            conversation_app_container.id = 'conversation-root';
            document.body.appendChild(conversation_app_container);
        }
        if (NSconfig.btn_img_url) {
            if (NSconfig.show_balloon) {
                conversation_app_container.innerHTML = '<div '+(NSconfig.open_from_balloon?'onclick="window.ConversationSDK.loadChat()" style="cursor: pointer"':'')+' id="chat_preview"><div onclick="document.getElementById(\'chat_preview\').style.display=\'none\'; event.stopPropagation(); window.event.cancelBubble = true; return false;" id="chat_preview_close">X</div><div id="chat_preview_content">'+(NSconfig.balloon_text?NSconfig.balloon_text:'In cosa posso esserti utile?')+'</div></div><div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><img src="' + NSconfig.btn_img_url + '" width="100%" height="100%" /></div>';
            }else{
                conversation_app_container.innerHTML = '<div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><img src="'+NSconfig.btn_img_url+'" width="100%" height="100%" /></div>';
            }
        }else {
            if (NSconfig.show_balloon) {
                conversation_app_container.innerHTML = '<div '+(NSconfig.open_from_balloon?'onclick="window.ConversationSDK.loadChat()" style="cursor: pointer"':'')+' id="chat_preview"><div onclick="document.getElementById(\'chat_preview\').style.display=\'none\'; event.stopPropagation(); window.event.cancelBubble = true; return false;" id="chat_preview_close">X</div><div id="chat_preview_content">'+(NSconfig.balloon_text?NSconfig.balloon_text:'In cosa posso esserti utile?')+'</div></div><div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><svg aria-hidden="true" data-prefix="fas" data-icon="comments" className="svg-inline--fa fa-comments fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"></path></svg></div>';
            }else{
                conversation_app_container.innerHTML = '<div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><svg aria-hidden="true" data-prefix="fas" data-icon="comments" className="svg-inline--fa fa-comments fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"></path></svg></div>';
            }
        }
        if (NSconfig.btn_bg_color){
            document.querySelector(".open_chat_btn").style.backgroundColor = NSconfig.btn_bg_color;
        }else if(NSconfig.base_color){
            document.querySelector(".open_chat_btn").style.backgroundColor = NSconfig.base_color;
        }
        document.querySelector(".open_chat_btn").style.opacity = 1;

        // setTimeout(() => {
            let hash = window.location.hash.substr(1);
            let payload_autoopen = undefined;
            console.info("WINDOW HASH", hash);
            if (hash){
                let hashes = hash.split("_");
                console.info("HASHES", hashes);
                if (hashes[0]=="cpayload"){

                    let payload = hash.substr(9);
                    console.info("PAYLOAD PRESENT",payload);
                    if (payload && payload!="" && payload.length>0) {
                        // ConversationSDK.loadChat('', payload);
                        payload_autoopen = payload;
                        console.info("PAYLOAD AUTOOPEN",payload_autoopen );
                    }
                }
                // remove fragment as much as it can go without adding an entry in browser history:
                window.location.replace("#");

                // slice off the remaining '#' in HTML5:
                if (typeof window.history.replaceState == 'function') {
                    history.replaceState({}, '', window.location.href.slice(0, -1));
                }else{

                }
            }
        var reopen_bounce = undefined;
        try{
            reopen_bounce = getCookie("reopen_bounce");
        }catch (e) {
        }

            if (payload_autoopen){
                ConversationSDK.loadChat('', payload_autoopen);
            }else if (NSconfig.autoopen){
                ConversationSDK.loadChat();
            }
            // else if(reopen_bounce != ""){
            //     try{
            //         deleteCookie("reopen_bounce");
            //     }catch (e) {
            //     }
            //     ConversationSDK.loadChat();
            // }

        // }, 1);

        window.addEventListener('message', function(event) {
            if (event.data=="close"){
                window.ConversationSDK.closeChat();
            }else if (event.data=="bounce"){
                let top = window.location.href;
                try {
                    setCookie("reopen_bounce", "reopen", 1);
                }catch (e) {
                }
                return window.location.href=service_ip+"/webchat_bounce?redirect="+encodeURIComponent(top);
            }
        });

    },

    loadChat: function(first_message_label, first_message_payload) {
        console.debug("loadChat", first_message_label, first_message_payload);
        document.body.classList.add("chat_mobile_overlay_active");
        let wcqs = '/app/'+NSconfig.api_key+"?v="+NSconfig.version;
        if ( first_message_label){
            wcqs+='&first_message_label='+first_message_label;
        }else if (NSconfig.first_message_label) {
            wcqs+='&first_message_label='+NSconfig.first_message_label;
        }
        if ( first_message_payload){
            wcqs+='&first_message_payload='+first_message_payload;
        }else if (NSconfig.first_message_payload) {
            wcqs+='&first_message_payload='+NSconfig.first_message_payload;
        }
        if (NSconfig.hide_close == true){
            wcqs+='&hide_close=1';
        }
        conversation_app_container .innerHTML = '<div style="opacity: 0" id="conversation_customer_chat_iframe_container" class="conversation_customer_chat_iframe_container mode-'+NSconfig.mode+'">' +
            '<div id="iframe_loader" class="chat-loading">\n' +
            '    <div class="lds-ellipsis">\n' +
            '        <div></div>\n' +
            '        <div></div>\n' +
            '        <div></div>\n' +
            '        <div></div>\n' +
            '    </div>\n' +
            '</div>' +
            '<iframe id="chat_iframe" ' +
            'width="100%" height="100%" frameborder="0" allowtransparency="true" ' +
            'allowfullscreen="true" scrolling="no" allow="encrypted-media" title="" ' +
            'src="'+service_ip+'/webchat'+wcqs+'"></iframe></div>';
        console.log("IFRAME SRC URL", service_ip+'/webchat'+wcqs);
        if (NSconfig.base_color) {
            let loading_div = document.querySelectorAll(".chat-loading .lds-ellipsis div");
            for (let i = 0; i < loading_div.length; i++) {
                loading_div[i].style.backgroundColor = NSconfig.base_color;
            }
        }
        setTimeout(()=>{
            document.getElementById('conversation_customer_chat_iframe_container').style.opacity=1;
            // document.getElementById('conversation_customer_chat_iframe_container').style.height="80vh";
        }, 1);
        document.getElementById('chat_iframe').onload= function() {
            setTimeout(()=>{
                document.getElementById('conversation_customer_chat_iframe_container').removeChild(document.getElementById('iframe_loader'));
                document.getElementById('chat_iframe').style.opacity = 1;
            },1)
        };
    },
    closeChat: function(){
        document.body.classList.remove("chat_mobile_overlay_active");
        document.getElementById('conversation_customer_chat_iframe_container').style.opacity = 0;
        setTimeout(()=>{

            if (NSconfig.btn_img_url) {
                conversation_app_container.innerHTML = '<div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><img src="'+NSconfig.btn_img_url+'" width="100%" height="100%" /></div>';
            }else {
                conversation_app_container.innerHTML = '<div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><svg aria-hidden="true" data-prefix="fas" data-icon="comments" className="svg-inline--fa fa-comments fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"></path></svg></div>';
            }

            //conversation_app_container.innerHTML = '<div id="open_chat_btn" class="open_chat_btn" onclick="window.ConversationSDK.loadChat()"><svg aria-hidden="true" data-prefix="fas" data-icon="comments" className="svg-inline--fa fa-comments fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"></path></svg></div>';
            if (NSconfig.btn_bg_color){
                document.querySelector(".open_chat_btn").style.backgroundColor = NSconfig.btn_bg_color;
            }else if(NSconfig.base_color){
                document.querySelector(".open_chat_btn").style.backgroundColor = NSconfig.base_color;
            }
            setTimeout(()=>document.getElementById("open_chat_btn").style.opacity=1,1);
        },1000);
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function deleteCookie(cname) {
    var d = new Date();
    d.setTime(d.getTime() - (100*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=;" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {

}

export default lib;



// WEBPACK FOOTER //
// ./webchat_loader.js